import React from "react";
import {GatsbyImage} from 'gatsby-plugin-image'
import { graphql } from "gatsby";

import Header from "../components/header";
import Seo from "../components/seo";


export default function TermsConditions({data}) {
   

    const {content, title, date} = data.wpPage

    React.useEffect(()=>{
        let content = document.getElementById('content-blog')
        function smoothScroll(e){
  
            content.scrollLeft += (e.deltaY * 0.4)

          
        }
  
  
        content.addEventListener('wheel', (e)=>smoothScroll(e))
        
  
        return () => content.removeEventListener('wheel', (e)=>smoothScroll(e))
  
      })

    return(
        <div className="relative overflow-hidden">
            <Header/>
                <main className="flex items-center pt-[80px] h-[100vh] transition-translate duration-100 ease-in-out overflow-x-auto overflow-y-hidden" id="content-blog" >
                    <div className="title-section px-4">
                        <h1 className="text-3xl md:text-6xl lg:text-9xl uppercase  my-4 leading-normal">{title}</h1>
                    </div>
                    <section dangerouslySetInnerHTML={{__html: content}} id="content-blog" className="rich-text-blog mr-[100px]"></section>
                </main>
        </div>
    )
}


export function Head({data}){

    const {seo} = data.wpPage
    
    return(
        <Seo
        title={seo.title}
        description={seo.metaDesc}
        url={data.site.siteMetadata.siteUrl + '/' + data.wpPage.slug}
        image={'../images/opengraph-royal.webp'}

      >    
      </Seo>
    )
  
  }




export const query = graphql`
    query Post{
        site{
            siteMetadata{
                siteUrl
            }
        }
        wpPage(slug: {eq: "terms-conditions"}) {
            content
            slug
            title
            seo{
                title
                metaDesc
                canonical
            }
        }
    }
`